import { Injectable } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BehaviorSubject, filter, map, shareReplay, throttleTime } from 'rxjs';
import { HelpSourceType } from '../shared/enums/HelpSourceType.enum';
import { AppSettingsService, SubdomainEnum } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class HelpSourceTypeService extends OnDestroyMixin{

  private _sourceType$ = new BehaviorSubject(this.appSettingService.subDomain === SubdomainEnum.GP ? HelpSourceType.toString(HelpSourceType.GpGeneral) : HelpSourceType.toString(HelpSourceType.LpGeneral));
  sourceType$ = this._sourceType$.pipe(
    shareReplay(1)
  );
  
  issueInput$ = new BehaviorSubject<string>('');
  content$ = new BehaviorSubject<string>('');

  constructor(
    private router: Router,
    private appSettingService: AppSettingsService
  ) { 
    super();

    this.router.events.pipe(
      untilComponentDestroyed(this),
      filter(event => event instanceof ActivationEnd && !event.snapshot.routeConfig.path?.includes("contact-us")),
      throttleTime(0),
      map((e: ActivationEnd) => e.snapshot.data)
   ).subscribe(data => {
    if(!!data && !!data['helpSourceType']){
       this._sourceType$.next(HelpSourceType.toString(data['helpSourceType']));
    }
    else{
      this._sourceType$.next(this.appSettingService.subDomain === SubdomainEnum.GP ? HelpSourceType.toString(HelpSourceType.GpGeneral) : HelpSourceType.toString(HelpSourceType.LpGeneral));
    }
   });
  }
}
